// For page specific styling, if needed more granualar styling add additionally to wrapper
export const PAGE_SPECIFIC_STYLES: { [key: string]: { wrapper: string } } = {
  default: {
    wrapper: 'bg-transparent',
  },
  'amazon-amc-audiences': {
    wrapper: 'bg-white',
  },
};
